import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import { Link } from 'react-router-dom'
// import Logo from '../../images/logotext1.png'
import './style.css'
import LoadingOverlay from '../loading/loading';
import service from '../../services/service';

const Footer = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getInformation();
    }, []);

    const getInformation = async () => {
        try {
            setLoading(true);
            const response = await service.view("information");
            if (response && !response.success) {
                toast.error(response.message);
                return;
            }
            setData(response.information)
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    }
    return (
        <footer className="wpo-site-footer">
            {loading && <LoadingOverlay />}
            <div className="wpo-upper-footer" style={{ padding: "30px 0px 0px" }}>
                <div className="wpo-footer-top">
                    <div className="container">
                        <div className="row">
                            {/* <div className="col-lg-6 col-md-6 col-sm-6 col-12 custom-grid">
                                <div className="logo widget-title">
                                    <img src={Logo} alt="logo" />
                                </div>
                            </div> */}
                            <div className="col-lg-6 col-md-6 col-sm-6 col-12 custom-grid">
                                <ul>
                                    {data && data.facebook && (
                                        <li>
                                            <Link
                                                to="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.open(data.facebook, "_blank");
                                                }}
                                            >
                                                <i className="ti-facebook"></i>
                                            </Link>
                                        </li>
                                    )}
                                    {data && data.twitter && (
                                        <li>
                                            <Link
                                                to="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.open(data.twitter, "_blank");
                                                }}
                                            >
                                                <i className="ti-twitter"></i>
                                            </Link>
                                        </li>
                                    )}
                                    {data && data.instagram && (
                                        <li>
                                            <Link
                                                to="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.open(data.instagram, "_blank");
                                                }}
                                            >
                                                <i className="ti-instagram"></i>
                                            </Link>
                                        </li>
                                    )}
                                    {data && data.telegram && (
                                        <li>
                                            <Link
                                                to="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.open(data.telegram, "_blank");
                                                }}
                                            >
                                                <i className="fa-brands fa-telegram"></i>
                                            </Link>
                                        </li>
                                    )}
                                    {data && data.whatsappNumber && (
                                        <li>
                                            <Link
                                                to="#"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    window.open(data.whatsappNumber, "_blank");
                                                }}
                                            >
                                                <i className="fa-brands fa-whatsapp"></i>
                                            </Link>
                                        </li>
                                    )}
                                </ul>

                            </div>
                        </div>
                        <p className="copyright">&copy; {new Date().getFullYear()} Ease My Trip. All rights reserved</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}
export default Footer;